import React, { PureComponent } from 'react';
import { getTranslate } from 'react-localize-redux';
import { Form, Select, Input } from 'antd';
import { connect } from 'react-redux';
import { setOtherForm } from './withdrawalActions';
import { withActions } from 'actionware/lib/withActions';
import bankLists from './../../utils/bank_list.json'

@connect(({ localize, profile: { profileData }, withdrawal: { otherForm } }) => ({
  translate: getTranslate(localize),
  profileData,
  otherForm
}))
@withActions({
  setOtherForm
})
@Form.create()
export default class BankAccount extends PureComponent {

  filterBanks = (inputValue, option) => {
    return (
      option.props.children
        .toLocaleLowerCase()
        .indexOf(inputValue.toLocaleLowerCase()) >= 0
    );
  };

  handleBankAccountChange = (data) => {
    this.props.setOtherForm((data === 'other'))
  }

  renderOtherForm = () => {
    const { translate, form, profileData } = this.props;
    const { getFieldDecorator } = form;
    const ruleRequired = {
      required: true,
      message: translate('validation.required.default')
    };
    const banks = bankLists.map((banklist) => {
      return <Select.Option key={`${banklist.code}`} value={`${banklist.bank_name}`}>{`${banklist.bank_name}`}</Select.Option>
    })
    return (
      <div>
        <Form.Item className={'bank'} label={translate('withdrawal.bank')}>
          {getFieldDecorator('bank', {
            rules: [ruleRequired]
          })(
            <Select
              className={'no-border'}
              showSearch
              optionFilterProp="children"
              filterOption={this.filterBanks}
              placeholder={translate('withdrawal.bankPlaceholder')}
            >
              {banks}
            </Select>
          )}
        </Form.Item>
        <Form.Item
          className={'bank-account-holder'}
          label={translate('withdrawal.bankAccountHolder')}
        >
          {getFieldDecorator('bankAccountHolder', {
            rules: [ruleRequired]
          })(
            <Input
              className={'no-border'}
              placeholder={translate('withdrawal.bankAccountHolderPlaceholder')}
            />
          )}
        </Form.Item>
        <Form.Item
          className={'bank-account-number'}
          label={translate('withdrawal.bankAccountNumber')}
        >
          {getFieldDecorator('bankAccountNumber', {
            rules: [ruleRequired]
          })(
            <Input
              className={'no-border'}
              placeholder={translate('withdrawal.bankAccountNumberPlaceholder')}
            />
          )}
        </Form.Item>
        <Form.Item
          className={'branch'}
          label={'Branch name'}>
          {
            getFieldDecorator('branch', {
              rules: [ruleRequired]
            })(
              <Input
                type={'text'}
                className={'no-border'}
                placeholder="Branch name" />
            )
          }
        </Form.Item>
        <Form.Item
          className={'city'}
          label={'City'}>
          {
            getFieldDecorator('city', {
              rules: [ruleRequired]
            })(
              <Input
                type={'text'}
                className={'no-border'}
                placeholder="City" />
            )
          }
        </Form.Item>
      </div>
    )
  }

  render() {
    const { translate, form, profileData, otherForm } = this.props;
    const { getFieldDecorator } = form;
    const ruleRequired = {
      required: true,
      message: translate('validation.required.default')
    };

    return (
      <Form>
        <Form.Item
          className={'bank'}
          label={translate('withdrawal.bankAccount')}
        >
          {getFieldDecorator('bankAccount', {
            rules: [ruleRequired]
          })(
            <Select
              className={'no-border'}
              onChange={this.handleBankAccountChange}>
              {
                profileData.BankAccounts.map(bankAccount => (
                  <Select.Option value={`${bankAccount.id}`}>{`${bankAccount.bank_name} - ${bankAccount.bank_account_holder} - ${bankAccount.bank_account}`}</Select.Option>
                ))
              }
              <Select.Option value={'other'}>Other</Select.Option>
            </Select>
          )}
        </Form.Item>
        {otherForm ? this.renderOtherForm() : ''}
      </Form>
    );
  }
}
